<div class="contents-wrapper" *ngIf="!loading">
  <div class="contents-container">
    <div class="page-header">{{ translations.monthlyCost }}</div>

    <zaver-list-slider
      [listOptions]="sliderListOptions"
      [(value)]="selectedSliderInputValue"
      [color]="primaryColor"
      [shouldHideControllerButtons]="false"
      (completedChange)="sliderValueChanged()"
    ></zaver-list-slider>

    <div class="loan-calculator-data">
      <div class="loan-calculator-data-table">
        <div
          *ngIf="nominalInterest && effectiveInterest"
          class="loan-calculator-data-table-row"
        >
          <div>
            <span>{{ translations.nominalAndEffectiveInterest }}</span>
          </div>
          <div>{{ nominalInterest }} % / {{ effectiveInterest }} %</div>
        </div>
        <div *ngIf="totalInterestFee" class="loan-calculator-data-table-row">
          <div>
            <span>{{ translations.totalInterestFee }}</span>
          </div>
          <div>{{ totalInterestFee }}</div>
        </div>
        <div *ngIf="adminFee" class="loan-calculator-data-table-row">
          <div>{{ translations.adminFee }}</div>
          <div>{{ adminFee }}</div>
        </div>
        <div *ngIf="initialFee" class="loan-calculator-data-table-row">
          <div>{{ translations.initialFee }}</div>
          <div>{{ initialFee }}</div>
        </div>
        <div class="loan-calculator-data-table-row">
          <div>{{ translations.totalAmount }}</div>
          <div>{{ totalAmount }}</div>
        </div>
      </div>

      <div class="loan-calculatior-data-divider"></div>

      <div class="loan-calculatior-data-info">
        <div class="info-header">{{ translations.proceed }}</div>
        <div class="list-item">{{ translations.stepOne }}</div>
        <div class="list-item">{{ translations.stepTwo }}</div>
        <div class="list-item">{{ translations.stepThree }}</div>
        <div class="info-footer">{{ translations.done }}</div>
      </div>
    </div>

    <div class="loan-calculator-terms">
      <p>
        {{ translations.termsOne }}
        <a target="_blank" [href]="termsUrl">{{ translations.termsTwo }} </a>
        {{ translations.termsThree }}
      </p>

      <p *ngIf="currentLoanTermsStr" class="calculation-terms">
        {{ translations.calculations }} {{ currentLoanTermsStr }}
      </p>
    </div>
  </div>
</div>

<div class="contents-wrapper" *ngIf="loading">
  <div class="contents-container">
    <app-spinner></app-spinner>
  </div>
</div>
